import {useIntl} from 'react-intl';
import {useKeycloak} from '@react-keycloak/web';
import config from '../../../../config';


function useLogin() {

    const {locale} = useIntl();
    const {keycloak} = useKeycloak();

    return (options = {}) => {

        let redirectUri = options.redirectUri || config.auth.redirectUri;
        if (options.toPath) {
            redirectUri += options.toPath;
        }

        keycloak.login({
            locale,
            redirectUri
        });
    };
}


export default useLogin;
